import React, { useContext } from 'react';
import { CashoutConfigurationContext } from '../data/cashout/CashoutConfigurationCtx';
import { ReactComponent as CashoutIcon } from '../assets/images/svg/tag_cashout_info.svg';

export default function CashoutLabel(props) {
    const cashoutConf = useContext(CashoutConfigurationContext);
    const bet = props.bet;
    let cashoutEnabled = false;
    
    const matchData = bet.odds[0]?.matchData ?? null;
    if (matchData != null) {
        cashoutEnabled = cashoutConf.isCashoutEnabledForSelection(matchData.sportRef,
                                                                  matchData.tournamentRef,
                                                                  matchData.pal,
                                                                  matchData.avv,
                                                                  bet.cs,
                                                                  bet.h,
                                                                  matchData.isLive);
    }
    
    if (!cashoutEnabled) {
        return null;
    }

    return (
        <CashoutIcon />
    );
}
